import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F5ECE1]">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="grid grid-cols-[auto,1fr] items-center gap-4 mb-8">
          <Link
            to="/"
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <ArrowLeft className="w-6 h-6" />
          </Link>
          <div className="flex justify-center">
            <img 
              src="https://qrmzfkvnksglemsiaxnp.supabase.co/storage/v1/object/public/website_assets//Framemyhome.png"
              alt="Framemyhome"
              className="h-10"
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <h1 className="text-3xl font-semibold text-gray-900 mb-8">Terms and Conditions</h1>

          {/* Product and Service Terms */}
          <section className="mb-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Product and Service Terms</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                By using Frame My Home's services, you agree to the following terms and conditions:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>No returns or exchanges are accepted once an order has been placed.</li>
                <li>It is the customer's responsibility to carefully inspect and approve the artwork before purchase.</li>
                <li>All frames are delivered with shatterproof acrylic glazing to ensure safe shipping and handling.</li>
                <li>Shipping times provided are indicative and may vary depending on order volumes and external factors.</li>
                <li>Frame My Home reserves the right to modify or cancel orders in case of technical issues or pricing errors.</li>
              </ul>
            </div>
          </section>

          {/* Privacy and Data Collection */}
          <section className="mb-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Privacy and Data Collection</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                We are committed to protecting your privacy and handling your data responsibly:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>We use Google Analytics to track website usage and improve our services.</li>
                <li>Payment information is securely processed through Stripe and is never stored on our servers.</li>
                <li>We collect and store only essential information needed to process your order and provide our services.</li>
                <li>Your email address will be used to send order confirmations, shipping updates, and essential service communications.</li>
                <li>We do not share your personal information with third parties except as necessary to fulfill your order.</li>
              </ul>
            </div>
          </section>

          {/* Order Process */}
          <section className="mb-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Order Process</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                Understanding our order process:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>No account creation is required to place an order.</li>
                <li>You will receive confirmation emails at key stages of your order.</li>
                <li>A tracking number will be provided once your item has been shipped.</li>
                <li>Orders cannot be modified once they have been submitted.</li>
                <li>Payment is processed securely through Stripe at the time of order.</li>
              </ul>
            </div>
          </section>

          {/* Contact Information */}
          <section className="mb-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Information</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                For any questions or concerns:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Email: <a href="mailto:support@framemyhome.ai" className="text-blue-600 hover:text-blue-800">support@framemyhome.ai</a></li>
                <li>Response time: We aim to respond to all inquiries within 24-48 business hours.</li>
              </ul>
            </div>
          </section>

          {/* Updates to Terms */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Updates to Terms</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                Frame My Home reserves the right to update these terms and conditions at any time without prior notice. Continued use of our services following any changes constitutes acceptance of the new terms.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms; 